<template>
  <div id="imageAtom" v-if="imagePath" :style="{width: extraStyle.width, height: extraStyle.height}">
    <img :src="getUrl(imagePath)" alt class="img-fluid" :style="extraStyle" />

    <div class="button-child-frame--container">
			<button 
        v-b-tooltip.hover
        title="Configuração da imagem"
				v-if="showSettings"
				class="button-child-frame button-setting-image mb-1"
				@click="() => $emit('openSettingsFrameChild')"
			>
				<i class="fal fa-cog fa-md"></i>
			</button>

			<button 
        v-b-tooltip.hover
        title="Excluir imagem"
				v-if="showSettings"
				class="button-child-frame button-delete-image"
				@click="() => $emit('deleteFrameChild')"
			>
				<i class="fal fa-trash-alt fa-md"></i>
			</button>
		</div>
  </div>
</template>
<script>
export default {
	name: "imageAtom",
	props: {
		imagePath: {
			type: String,
			default: null,
		},
    isFullWidth: {
      type: Boolean,
      default: false,
    },
    extra: {
      type: Object,
      default: null,
    },
    imageWidth: {
      type: String | Number,
      default: '0',
    },
    imageHeight: {
      type: String | Number,
      default: '0',
    },
    showSettings: {
      type: Boolean,
      default: false,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
	},
	methods: {
		getExt(str){
      if(str){
        str = str.toLowerCase().split(".");
        return str[str.length - 1];
      }
      else{
        return null
      }
	  },
    getUrl(picture) {
      const pictureExtension = this.getExt(picture);

      if (pictureExtension === 'svg' || pictureExtension === 'gif') {
        return `${process.env.CONTAINER_URL}${picture}`;
      }

      // Validando pois a imagem pode vir sem o valor de width e height (principalmente se for preset)
      let fitIn = `${this.imageWidth || 0}x${this.imageHeight || 0}`;

      if (this.imageWidth > process.env.IMAGE_WIDTH_MAX) {
        fitIn = `${process.env.IMAGE_WIDTH_MAX}x0`;
      }

      if (this.imageHeight > process.env.IMAGE_HEIGHT_MAX) {
        fitIn = `0x${process.env.IMAGE_HEIGHT_MAX}`;
      }

      return `${process.env.CDN_URL}${fitIn}/${picture}`;
    }
	},
  computed: {
    extraStyle() {
      let style = {};

      style = {
        ...this.extra.style,
      }

      if (!this.isFullWidth) {
        if (this.extra.style_width_lock) {
          style.width = '100%';
        }

        if (this.extra.style_height_lock) {
          style.height = '100%';
        }
      } else {
        style.objectFit = 'cover';
        style.width = '100%';

        if (this.extra.style_height_lock) {
          style.height = '100%';
        }
      }

      if (!this.isChild) {
        style.width = '100%';
        style.objectFit = 'cover';
      }

      return style;
    }
  },
  created() {
    if (!this.extra) {
      this.extra = {}
    }
  }
};
</script>

<style scoped>
#imageAtom {
  position: relative;
}

#imageAtom .button-delete-image {
  opacity: 0;
  transition: opacity 300ms ease-in-out;
}

#imageAtom:hover .button-delete-image {
  opacity: 1;
  transition: opacity 300ms ease-in-out;
}

#imageAtom .button-child-frame--container {
  position: absolute;
  top: 0;
  bottom: 0;
  right: -6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#imageAtom .button-child-frame {
  border: 1px solid #dddddd;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  min-width: 26px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#imageAtom .button-child-frame:hover {
  background-color: var(--main-color);
  border: 1px solid var(--main-color);
  color: #fff;
}

#imageAtom .button-child-frame {
  opacity: 0;
  transition: all 300ms ease-in-out;
}

#imageAtom:hover .button-child-frame {
  opacity: 1;
  transition: all 300ms ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/ImageBlock.vue